import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // model
  serviceTypeModel: [],

  //form
  buttonId: null,

  // 選択されたお知らせタイプリスト
  value: []
}

const getters = {
	get: state => state
}

const actions = {
	show ({commit}, {buttonId, data}) {
		// cover
		this.dispatch('core/showModalCover')
		
    commit('reset')
    commit('setButtonId', buttonId)
    commit('setValue', data)
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
	},

  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {serviceTypeParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['const'],
        ['v1ServiceTypeListGet'],
        [serviceTypeParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setServiceTypeModel', res[0].data.serviceTypes)
            console.log('serviceTypeModel', state.serviceTypeModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * 選択されたファイル情報を保持
   */
  setValue ({commit}, data) {
    commit('setValue', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // model
  setServiceTypeModel (state, data) {
    Vue.set(state, 'serviceTypeModel', data)
  },
  
  // form
  setButtonId (state, id) {
    state.buttonId = id
  },
  setValue (state, data) {
    Vue.set(state, 'value', data)
  },

  // reset
  reset (state) {
    Vue.set(state, 'serviceTypeModel', [])
    Vue.set(state, 'value', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
